import { relocationEntity } from "../../domain/entities/relocation_entity";
import http from "../../../../plugins/http-common"
import { RelocationContract } from "../../domain/contracts/relocation_contract";
import { relocationIndexEntity } from "../../domain/entities/relocation_index_entity";
import { relocationLocationsEntity } from "../../domain/entities/relocation_locations_entity";
import { relocationProductsEntity } from "../../domain/entities/relocation_products_entity";
import { relocationPalletEpcEntity } from "../../domain/entities/relocation_pallet_epc_entity";
// import i18n from "../../../i18n";

export const HttpRelocationRepository = {
  ...RelocationContract,
  model: relocationEntity,
  model_index: relocationIndexEntity,
  model_locations: relocationLocationsEntity,
  model_products: relocationProductsEntity,
  model_validate_location: relocationPalletEpcEntity,

  async index(page, per_page, search, sort_by) {
    var sort = ""

    if(sort_by.length > 0) sort = '&sort=' + sort_by[0].field + '&sort_direction=' + sort_by[0].direction;

    const res = await http.get('relocations?page=' + page + '&per_page=' + per_page + sort + '&search=' + search);

    return res;
  },

  async relocate_all_in_location(location_id) {
    const res = await http.get('relocations/relocate_all_in_location?location_id=' + location_id );
    
    return res;
  },

  async get_locations(client_id, occupied) {
    const res = await http.get('relocations/get_locations?client_id=' + client_id + '&occupied=' + occupied);

    return res;
  },

  async get_products_by_location(location_id) {
    const res = await http.get('relocations/get_products_by_location?location_id=' + location_id)

    return res;
  },

  async relocate(data) {
    const res = await http.post('relocations', data);

    return res;
  },

  async validate_location(pallet_epc) {
    const res = await http.get('relocations/location/' + pallet_epc);

    return res;
  },

  async validate_location_by_client (client_id, identifier, identifier_type) {
    const res = await http.get('relocations/validate-location?client_id=' + client_id + '&identifier=' + identifier + '&identifier_type=' + identifier_type);

    return res;
  },

  async get_pallets(location_id) {
    const res = await http.get('relocations/get_pallets_of_destination?location_id=' + location_id);

    return res;
  },

  async relocate_with_tag(data) {
    const res = await http.post('relocations/epc', data);

    return res;
  }
};